<template>
    <div class="page">
        <el-form v-if="send" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
            <el-form-item label="">
                <el-input placeholder="角色名" v-model="queryForm.roleName"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="checkState = 'check'">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="checkState = 'reset'">重置</el-button>
            </el-form-item>
        </el-form>
        <RoleListTable :data="this.data" @send="getData" :queryForm="queryForm" :checkState="checkState" @resetCheckState="resetCheckState"></RoleListTable>
    </div>
</template>

<script>
import RoleListTable from '@/components/organization/RoleListTable.vue';

export default {
    components: {
        RoleListTable
    },
    data() {
        return {
            queryForm: {
                roleName: ''
            },
            send: '',
            checkState: '',
            data : '',
        };
    },
    methods: {
        getData(data){
            this.send = data;
        },
        resetCheckState() {
            if (this.checkState == 'reset') {
                this.queryForm = {
                    roleName: ''
                };
            }
            this.checkState = '';
        }
    }
};
</script>

<style lang="scss" scoped></style>
